import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  Typography,
} from '@mui/material';
import { useMatch, useNavigate } from 'react-router-dom';
import backV1 from 'assets/images/backV1.svg';

export const CustomNavbar: React.FC<{ title: string }> = ({
  title = 'N/A',
}) => {
  const navigate = useNavigate();
  const match = useMatch('/location/:locationTypeParams');
  const handleBackClick = () => {
    navigate(-1);
  };

  if (match?.params.locationTypeParams !== undefined) {
    title =
      match?.params.locationTypeParams === 'out'
        ? 'Pickup Location'
        : 'Return Location';
  }
  return (
    <Box>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: 'unset',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          width: '90%',
          margin: 'auto',
        }}
      >
        <Toolbar>
          <Button onClick={handleBackClick} sx={{ position: 'absolute' }}>
            <img src={backV1} alt="Back-btn" className="back-btn" />
          </Button>
          <Typography className="navbarTitle" color="primary" variant="body1">
            {title === 'Information' ? 'Customer ' : 'CHOOSE YOUR '}
            <span style={{ textDecoration: 'underline', fontWeight: '600' }}>
              {title.toUpperCase()}
            </span>
          </Typography>
        </Toolbar>
      </AppBar>
      <Divider
        sx={{
          backgroundColor: 'lightgray',
          height: '1px',
        }}
      />
    </Box>
  );
};
